import { CreateMpnActionType, CreateMpnActionTypes, CreateMpnState, } from "./data";
import { IMpnInformation, IMpnRequest } from "../../../../types/data.interface";

const initialState: CreateMpnState = {
  itemNumber: null,
  requestorInfo: {
    full_name: "",
    id: "",
    short_name: "",
  },
  composition: {
    id: "",
    molded_components: [],
    name: "",
    non_molded_components: [],
    mpns: [],
    skus: [],
  },
  unSavedChanges: false,
  isSavingOrSubmiting: false,
  mpnData: {
    tps_product: "N",
    tps_loc_id: null,
    tps_type_id: null,
    production_lifecycle_status: "Active",
    sales_lifecycle_status: "Active",
    giftbox: "N",
  } as IMpnInformation,
  mpnRequest: {
    request_date: "",
    requested_by: "",
    revision: "",
    status: "CREATED",
    item_description: "",
  } as IMpnRequest,
  isChangedImportedValues: false,
  selectedItemNumberCompositionRows: [],
  selectedGpCompositionRows:[],
  selectedMoldIndexes: [],
  isLoading: false,
  mpnToClone: null,
};

const reducer = (
  state: CreateMpnState,
  action: CreateMpnActionType,
): CreateMpnState => {

  
  if (action.type === CreateMpnActionTypes.SET_GLOBAL_PRODUCT) {
    return {
      ...state,
      global_product: action.payload,
      category: action.payload?.sub_category?.parent,
      sub_category: action.payload?.sub_category,
      product_line: action.payload?.product_line,
    };
  }

  if (action.type === CreateMpnActionTypes.SET_SUB_CATEGORY) {
    return {
      ...state,
      sub_category:action.payload,
      // @ts-ignore
      category: action.payload?.parent,
      global_product: null,
      product_line: null,
    };
  }

  if (action.type === CreateMpnActionTypes.SET_MPN) {
    return { ...state, ...action.payload };
  }

  return { ...state, [action.type]: action.payload };
};

export const CreateMpnReducer = { initialState, reducer };
